import { Route } from '@angular/router';

export const cricketTacticsStatisticsRoutes: Route[] = [
    {
        path: 'cricket-tactics/details',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/cricket-tactics-statistics-details/cricket-tactics-statistics-details.component').then(
                (c) => c.CricketTacticsStatisticsDetailsComponent
            ),
    },
    {
        path: 'cricket-tactics/games/tab/:tab',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/cricket-tactics-statistics-games/cricket-tactics-statistics-games.component').then(
                (c) => c.CricketTacticsStatisticsGamesComponent
            ),
    },
    {
        path: 'cricket-tactics/games/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import(
                './pages/cricket-tactics-statistics-games-details/cricket-tactics-statistics-games-details.component'
            ).then((c) => c.CricketTacticsStatisticsGamesDetailsComponent),
    },
];
